import header from './bingo/section-header';
import section1 from './bingo/section-1';
import section2 from './bingo/section-2';
import section3 from './bingo/section-3';
import section4 from './bingo/section-4';
import section5 from './bingo/section-5';
import pSelect from "./bingo/select";

new pSelect('#p-select1');
new pSelect('#p-select2');



var page = promokit.page({
    type: 'basic',

    game: 'bns',

    cnb: true,

    headerButton: {
        el: '.header-button',
        home: true,
        sns: true,
        theme: 'black',
        event: true
    },

    topButton: true,

    caution: '#section-caution',

    remote: {
        header: '#section-header',
        title: '천명절, 빈(頻)고(鼓)오(五)',
        home: true,
        template: `<ul>
                  <li><a href="#section-1">빈(頻)고(鼓)오(五)를 위한 준비물 지원</a></li>
                  <li><a href="#section-2">빈(頻)고(鼓)오(五) 놀이</a></li>
                  <li><a href="#section-3">천명의 축복</a></li>
                  <li><a href="#section-4">천명절, 특별 교환권</a></li>
                  <li><a href="#section-5">천명절, 특급 성장 지원</a></li>
                </ul>`
    },

    footer: {},

    components: [
        header,
        section1,
        section2,
        section3,
        section4,
        section5,
    ],
});


// WEBPACK FOOTER //
// ./src/js/bingo.js